import React, { useCallback, useEffect, useState } from "react";
import { useProps } from "./Props.hook";
import { getPropType } from "../helpers/getPropType.helper";
import { updateProps } from "../helpers/setPropValue.helper";
const ItemPropsContext = /*#__PURE__*/React.createContext({
  propsFromItem: {},
  updatePropFromItem: () => null,
  getPropsForComponent: () => ({})
});
const buildProps = (propsFromBio, inheritedProps, propTypes) => {
  const propsObj = {
    ...propsFromBio
  };
  if (inheritedProps) {
    Object.entries(inheritedProps).forEach(_ref => {
      var _propsObj$key, _propsObj$key2;
      let [key, value] = _ref;
      return propsObj[key] = {
        type: getPropType(propTypes, key, value, (_propsObj$key = propsObj[key]) === null || _propsObj$key === void 0 ? void 0 : _propsObj$key.type),
        title: ((_propsObj$key2 = propsObj[key]) === null || _propsObj$key2 === void 0 ? void 0 : _propsObj$key2.title) || (typeof (propTypes === null || propTypes === void 0 ? void 0 : propTypes[key]) === "object" ? propTypes[key].title : key) || key,
        value
      };
    });
  }
  if (propTypes) {
    Object.entries(propTypes).forEach(_ref2 => {
      let [key, value] = _ref2;
      if (typeof propsObj[key] === "undefined") {
        propsObj[key] = {
          type: typeof value === "string" ? value : value.type,
          title: typeof value === "object" && value.title ? value.title : key,
          value: undefined
        };
      } else {
        propsObj[key].type = (typeof value === "string" ? value : value.type) || propsObj[key].type;
        propsObj[key].title = typeof value === "object" && value.title ? value.title : propsObj[key].title;
      }
    });
  }
  return propsObj;
};
export const ItemPropsProvider = _ref3 => {
  let {
    props: inheritedProps,
    propTypes,
    children
  } = _ref3;
  const {
    propsFromBio
  } = useProps();
  const [propsFromItem, setPropsFromItem] = useState(() => buildProps(propsFromBio, inheritedProps, propTypes));
  const updatePropFromItem = useCallback((prop, value) => {
    setPropsFromItem(prevState => updateProps(prevState, prop, value));
  }, []);
  const getPropsForComponent = useCallback(() => Object.entries(propsFromItem).reduce((obj, _ref4) => {
    let [key, data] = _ref4;
    return {
      ...obj,
      [key]: data.value
    };
  }, {}), [propsFromItem]);
  useEffect(() => {
    setPropsFromItem(buildProps(propsFromBio, inheritedProps, propTypes));
  }, [propsFromBio, inheritedProps, propTypes]);
  return /*#__PURE__*/React.createElement(ItemPropsContext.Provider, {
    value: {
      propsFromItem,
      updatePropFromItem,
      getPropsForComponent
    }
  }, children);
};
export const useItemProps = () => React.useContext(ItemPropsContext);
//# sourceMappingURL=ItemProps.hook.js.map